// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {LabelSmallText} from '../core/Type';
import Glyph from '../core/Glyph';
import {FlexibleSpace} from '../core/Spacing';

// Temporary select box control that's actually functional. TODO: Remove this once the SelectBox component is functional.
export class TempSelectBox extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            selectBox: {
                height: CoreMetrics.ElementHeight.Small(),
                display: "flex",
                alignItems: "center",
                justifyItems: "stretch",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                borderRadius: CoreMetrics.CornerRadius,
                outline: "none",
                paddingTop: 0,
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
                border: 0,
                // Typography
                fontFamily: CoreMetrics.Type.Font.SansSerifRegular,
                fontWeight: 400,
                fontSize: CoreMetrics.Type.SansSerif.Medium.Size(),
                lineHeight: CoreMetrics.Type.LineHeight.Label,
            },
        });

        const {items, selectedIndex} = this.props;
        return (
            <select className={css(styles.selectBox, styles.selectBox, CoreStyles.hairlineOuterStroke)} onChange={this.handleChange} value={selectedIndex}>
                {items.map((option, i) => {
                        const key = "option-" + i;
                        return <option key={key} value={i}>{option}</option>;
                })}
            </select>
        );
    }
    handleChange = (event) => {
        const element = event.target;
        const i = element.selectedIndex;
        const changeHandler = this.props.changeHandler;
        if (changeHandler != null) {
            changeHandler(i);
        }
    }
}

export default class SelectBox extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            selectBox: {
                height: CoreMetrics.ElementHeight.Small(),
                display: "flex",
                alignItems: "center",
                justifyItems: "stretch",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                borderRadius: CoreMetrics.CornerRadius,
                outline: "none",
                paddingTop: 0,
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
            },
            dropdown: {
                marginLeft: CoreMetrics.ElementPadding.XXSmall(),
            },
        });

        const {placeholder, options} = this.props;
        let optionElements = [];
        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            const optionElement = <option value={i}>{option}</option>;
            optionElements.push(optionElement);
        }
        return (
            <div className={css(styles.selectBox, CoreStyles.hairlineOuterStroke, this.props.styles)}>
                <LabelSmallText styles={[CoreStyles.PlaceholderText]}>{placeholder}</LabelSmallText>
                <FlexibleSpace />
                <Glyph styles={[styles.dropdown]} asset="assets/12x12-dropdown.svg" size={Glyph.Size.XSmall} fillColor={CoreMetrics.Color.Neutral.OffBlack} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/controls/SelectBox.jsx